import React, { useState, useEffect } from 'react';
import Nav from './nav';
import Logo from '../../../assets/images/Logo';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/80 backdrop-blur-xl shadow-lg shadow-dark-900/5 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container-lg">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 group">
            <div className="relative">
              <div className="absolute inset-0 bg-primary-500 rounded-xl blur-lg opacity-0 group-hover:opacity-40 transition-opacity duration-300" />
              <Logo />
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold text-dark-900 tracking-tight">
                Agal
              </span>
              <span className="text-2xs text-dark-400 font-medium tracking-wide uppercase">
                Software Solutions
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <Nav />

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a href="#contact" className="btn btn-primary btn-md">
              <span className="relative z-10">Start a Project</span>
              <svg className="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden relative w-10 h-10 flex items-center justify-center rounded-xl hover:bg-dark-100 transition-colors"
            aria-label="Toggle menu"
          >
            <div className="w-5 h-4 flex flex-col justify-between">
              <span
                className={`block h-0.5 bg-dark-700 rounded-full transition-all duration-300 ${
                  mobileMenuOpen ? 'rotate-45 translate-y-1.5' : ''
                }`}
              />
              <span
                className={`block h-0.5 bg-dark-700 rounded-full transition-all duration-300 ${
                  mobileMenuOpen ? 'opacity-0' : ''
                }`}
              />
              <span
                className={`block h-0.5 bg-dark-700 rounded-full transition-all duration-300 ${
                  mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
              />
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-500 ease-smooth ${
            mobileMenuOpen ? 'max-h-96 opacity-100 mt-6' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="flex flex-col gap-2 py-4 border-t border-dark-100">
            {['Home', 'Services', 'Solutions', 'Process'].map((item) => (
              <a
                key={item}
                href={item === 'Home' ? '/' : `#${item.toLowerCase()}`}
                className="px-4 py-3 text-dark-600 font-medium rounded-xl hover:bg-primary-50 hover:text-primary-600 transition-all"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item}
              </a>
            ))}
            <a
              href="#contact"
              className="btn btn-primary btn-md mt-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="relative z-10">Start a Project</span>
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
